<template>
    <v-dialog v-model="dialog" persistent max-width="450" @keydown.esc="chiudi(false)">
        <v-card height="250" :loading="attesa">
            <v-toolbar dark color="primary" dense>
                <v-btn icon dark v-on:click="chiudi()">
                    <v-icon>close</v-icon>
                </v-btn>
                <v-toolbar-title>Impostazioni</v-toolbar-title>
                <v-spacer></v-spacer>

                <v-toolbar-items>
                    <v-btn text v-on:click="salva()" :disabled="attesa" :loading="attesa">Ok
                        <v-icon right>save</v-icon>
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>

        </v-card>

    </v-dialog>
</template>


<script>
export default {
    props: {
        dialog: { type: Boolean, default: false },
    },

    data: () => ({
        attesa: false,

        dati: {},


    }),

    methods: {
        caricaDati() {

        },

        chiudi() {
            this.$emit("chiudiDialog");
        }
    },

    watch: {
        dialog() {
            this.caricaDati();
        },
    },
};
</script>
